import { defineAsyncComponent } from 'vue'

// import Http from './src/http/index'
export * from './src/4a-config'
export * from './src/hooks/useShowTreasuryAuthDialog'
export * from './src/store/treasury-auth'
export * from './src/utils/index'
export const JKAuthDialog = defineAsyncComponent(() => import('./src/components/index.vue'))
